import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { stringify as stringifyParams } from 'hub-http/helpers/params';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { getThemeQueryFieldUrl } from '../../utils/themeQuery';

const RouterFilterButton = (_ref) => {
  let {
    queryField,
    value
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["queryField", "value"]);

  const computedLocation = useMemo(() => {
    const paramsString = stringifyParams({
      [`eco_${queryField}`]: value
    });
    let path;

    if (Array.isArray(value) && value.length === 1) {
      path = getThemeQueryFieldUrl(queryField, value[0]);
    } else if (typeof value === 'string') {
      path = getThemeQueryFieldUrl(queryField, value);
    }

    return path ? `/${path}` : `/all?${paramsString}`;
  }, [queryField, value]);
  return /*#__PURE__*/_jsx(UIRouterButton, Object.assign({}, rest, {
    to: computedLocation
  }));
};

export default RouterFilterButton;